<script>
    import { onMount } from 'svelte';

    wyvr: {
        render: 'hydrate';
        loading: 'instant';
    }
    onMount(() => {
        let timer;
        window.addEventListener('scroll', () => {
            clearTimeout(timer);
            timer = setTimeout(() => {
                is_visible = document.body.scrollTop > 20 || document.documentElement.scrollTop > 20;
            }, 100);
        });
    });
    let is_visible = false;
</script>

<a href="#top" id="scroll-to-top-btn" type="button" class:is_visible aria-label={'Zum Seitenanfang'}>
    <span aria-hidden="true" class="icon-up" />
</a>


<style>
    a {
        background: var(--brown) none;
        font-weight: 300;
        font-size: 1.2rem;
        position: fixed;
        right: 20px;
        bottom: 80px;
        z-index: 11;
        padding: 15px;
        color: var(--darkblue);
        cursor: pointer;
        opacity: 0;
        text-decoration: none;
        display: flex;
        pointer-events: none;
    }
    @media (min-width: 640px) {
        a {
            bottom: 120px;
        }
    }
    .is_visible {
        pointer-events: all;
        opacity: 0.6;
        transition: all 0.5s ease-in-out;
        transform: scale(0.95);
    }
    .is_visible:hover,
    .is_visible:focus {
        opacity: 1;
        transform: scale(1);
    }
</style>